import { Snackbar, SnackbarContent, Stack } from "@mui/material";
import { useTheme } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import { useIsMobile } from "src/utils/hooks/useIsMobile";

interface CopySnackbarProps {
  open: boolean;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
}

function CopySnackbar(props: CopySnackbarProps) {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const { open, handleClose } = props;

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => handleClose}
      action={<CloseIcon onClick={() => handleClose} fontSize="small" />}
    >
      <SnackbarContent
        sx={{
          color: "#fff",
          backgroundColor: theme.palette.secondary.main,
          fontWeight: theme.typography.fontWeightBold,
          fontFamily: theme.typography.fontFamily,
        }}
        message={
          <>
            <Stack spacing={15} direction="row" sx={{ alignItems: "center" }}>
              <span className="snackbarMsg">
                <div>Copied to clipboard</div>
              </span>
              {!isMobile && <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleClose} />}
            </Stack>
          </>
        }
      />
    </Snackbar>
  );
}

export default CopySnackbar;
